
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ClientsSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const ClientsSearch: React.FC<ClientsSearchProps> = ({
  searchTerm,
  onSearchChange,
}) => {
  return (
    <div className="relative w-full max-w-sm">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
      <Input
        type="text"
        placeholder="Buscar por nombre o RNC..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
};

export default ClientsSearch;
